/** Textos en español (idioma principal, ADR 0005). Las claves son la fuente de verdad para `en`. */
export const es = {
  'app.title': 'VOLT · Operación',
  'app.loading': 'Cargando…',
  'app.error': 'Ocurrió un error',
  'app.retry': 'Reintentar',
  'app.save': 'Guardar',
  'app.cancel': 'Cancelar',
  'app.confirm': 'Confirmar',
  'app.close': 'Cerrar',
  'app.search': 'Buscar',
  'app.none': 'Sin registros',
  'app.yes': 'Sí',
  'app.no': 'No',
  'app.all': 'Todos',
  'app.actions': 'Acciones',
  'app.reason': 'Motivo',
  'app.reasonHelp': 'Queda en la auditoría',
  'app.refresh': 'Actualizar',
  'app.language': 'Idioma',
  'app.signOut': 'Salir',
  'app.role': 'Rol',
  'app.status': 'Estado',
  'app.created': 'Creado',
  'app.updated': 'Actualizado',
  'app.details': 'Detalle',
  'app.more': 'Más',
  'app.copy': 'Copiar',
  'app.copied': 'Copiado',
  'app.back': 'Volver',
  'app.forbidden': 'No tienes permiso para esta acción',
  'app.notFound': 'No encontrado',
  'app.theme': 'Tema',
  'app.theme.system': 'Tema: sistema',
  'app.theme.light': 'Tema: claro',
  'app.theme.dark': 'Tema: oscuro',
  'session.state.REQUESTED': 'Solicitada',
  'session.state.AUTHORIZED': 'Autorizada',
  'session.state.STARTING': 'Iniciando',
  'session.state.CHARGING': 'Cargando',
  'session.state.SUSPENDED_EV': 'Pausada por el vehículo',
  'session.state.SUSPENDED_EVSE': 'Pausada por el cargador',
  'session.state.STOPPING': 'Deteniendo',
  'session.state.ENDED': 'Terminada',
  'session.state.SETTLED': 'Liquidada',
  'session.state.PAID': 'Pagada',
  'session.state.FAILED': 'Fallida',
  'session.state.EXPIRED': 'Expirada',
  'session.state.CANCELLED': 'Cancelada',
  'payment.status.PAID': 'Pagado',
  'payment.status.CAPTURED': 'Cobrado',
  'payment.status.APPROVED': 'Aprobado',
  'payment.status.SUCCEEDED': 'Aprobado',
  'payment.status.PENDING': 'Pendiente',
  'payment.status.AUTHORIZED': 'Autorizado',
  'payment.status.FAILED': 'Fallido',
  'payment.status.DECLINED': 'Rechazado',
  'payment.status.ERROR': 'Error',
  'payment.status.REFUNDED': 'Devuelto',
  'payment.status.VOIDED': 'Anulado',
  'payment.status.CANCELLED': 'Cancelado',
  'payment.status.NONE': 'Sin cobro',
  'payment.status.OPEN': 'Deuda abierta',
  'payment.status.WAIVED': 'Condonado',
  'payment.status.WALLET': 'Saldo',
  'severity.CRITICAL': 'Crítica',
  'severity.WARNING': 'Advertencia',
  'severity.INFO': 'Informativa',
  'app.renderError': 'Esta pantalla falló al mostrarse. El resto del back-office sigue disponible.',
  'app.renderRetry': 'Reintentar',
  'app.openInNewTab': 'Abrir en otra pestaña',

  'nav.dashboard': 'Ahora',
  'nav.sites': 'Sedes',
  'nav.chargePoints': 'Cargadores',
  'nav.sessions': 'Sesiones',
  'nav.tariffs': 'Tarifas',
  'nav.simulator': 'Simulador',
  'nav.parameters': 'Parámetros',
  'nav.payments': 'Pagos',
  'nav.drivers': 'Conductores',
  'nav.alarms': 'Alarmas',
  'nav.audit': 'Auditoría',
  'nav.staff': 'Personal',
  'nav.integrations': 'Integraciones',

  'login.title': 'Entrar al back-office',
  'login.email': 'Correo',
  'login.password': 'Contraseña',
  'login.submit': 'Entrar',
  'login.forgot': 'Olvidé mi contraseña',
  'login.resetSent': 'Te enviamos un correo para restablecer la contraseña',
  'login.tokenTitle': 'Laboratorio: token de administración',
  'login.token': 'Token (API_ADMIN_TOKEN)',
  'login.tokenActor': 'Actor (opcional, p. ej. staff:ana)',
  'login.tokenSubmit': 'Entrar con token',
  'login.noProvider': 'La API no tiene configurado un proveedor de identidad',
  'login.mfaCode': 'Código del autenticador',
  'login.mfaTitle': 'Segundo factor',
  'login.mfaHelp': 'Escribe el código de 6 dígitos de tu app de autenticación',
  'login.verifyEmail': 'Debes verificar tu correo antes de entrar. Revisa tu bandeja de entrada.',
  'login.resendVerification': 'Reenviar correo de verificación',
  'login.verificationSent': 'Correo de verificación enviado',
  'login.notInvited':
    'Este correo no tiene invitación al back-office. Pide a un administrador que te invite.',
  'login.disabled': 'Tu cuenta está deshabilitada.',
  'login.reauth': 'Tu sesión superó la antigüedad máxima. Vuelve a entrar.',
  'login.wrongCredentials': 'Correo o contraseña incorrectos',
  'login.tooMany': 'Demasiados intentos. Espera unos minutos.',

  'mfa.title': 'Activa el segundo factor (TOTP)',
  'mfa.intro':
    'Tu rol exige un segundo factor. Escanea el código con Google Authenticator, Authy o similar y escribe el código que muestra.',
  'mfa.secret': 'Clave manual',
  'mfa.code': 'Código de 6 dígitos',
  'mfa.activate': 'Activar',
  'mfa.done': 'Segundo factor activado. Vuelve a entrar para continuar.',
  'mfa.reauthTitle': 'Confirma tu contraseña',
  'mfa.reauthHelp': 'Por seguridad, confirma tu contraseña para activar el segundo factor.',
  'mfa.notEnabled':
    'MFA TOTP no está habilitado en Identity Platform para este proyecto. Pídelo al administrador de Google Cloud.',

  'dash.title': 'Ahora',
  'dash.chargePoints': 'Cargadores',
  'dash.online': 'En línea',
  'dash.offline': 'Sin conexión',
  'dash.activeSessions': 'Sesiones activas',
  'dash.openAlarms': 'Alarmas abiertas',
  'dash.connectors': 'Conectores',
  'dash.map': 'Mapa',
  'dash.list': 'Lista',
  'dash.noSites': 'Aún no hay sedes. Crea la primera en Sedes.',
  'dash.lastSeen': 'Última señal',
  'dash.critical': 'críticas',
  'dash.warning': 'avisos',

  'map.loading': 'Cargando el mapa…',
  'map.noKey':
    'El mapa de Google no está configurado en este ambiente (falta la clave GOOGLE_MAPS_BROWSER_KEY). La lista muestra la misma información.',
  'map.authFailure':
    'Google Maps rechazó la clave de este ambiente. Revisa la restricción por dominio de la clave en Google Cloud.',
  'map.network': 'No se pudo cargar Google Maps. Revisa la conexión e intenta de nuevo.',
  'map.open': 'Ver sede',
  'map.pickHelp':
    'Haz clic en el mapa (o arrastra el marcador) para fijar la ubicación de la sede; las coordenadas se llenan solas.',

  'sites.title': 'Sedes',
  'sites.new': 'Nueva sede',
  'sites.code': 'Código',
  'sites.name': 'Nombre',
  'sites.address': 'Dirección',
  'sites.city': 'Ciudad',
  'sites.latitude': 'Latitud',
  'sites.longitude': 'Longitud',
  'sites.timezone': 'Zona horaria',
  'sites.accessType': 'Acceso',
  'sites.chargePoints': 'Cargadores',
  'sites.created': 'Sede creada',

  'cp.title': 'Cargadores',
  'cp.new': 'Nuevo cargador',
  'cp.chargeBoxId': 'Identidad (chargeBoxId)',
  'cp.site': 'Sede',
  'cp.vendor': 'Fabricante',
  'cp.model': 'Modelo',
  'cp.serial': 'Serie',
  'cp.firmware': 'Firmware',
  'cp.lifecycle': 'Ciclo de vida',
  'cp.connected': 'Conectado',
  'cp.disconnected': 'Desconectado',
  'cp.lastSeen': 'Última señal',
  'cp.connectors': 'Conectores',
  'cp.qr': 'QR',
  'cp.connector': 'Conector',
  'cp.standard': 'Estándar',
  'cp.powerType': 'Tipo',
  'cp.maxPower': 'Potencia máx.',
  'cp.maxPowerKw': 'Potencia máx. (kW)',
  'cp.cabinetPower': 'Potencia del gabinete',
  'cp.cabinetPowerKw': 'Potencia del gabinete (kW)',
  'cp.cabinetPowerHelp':
    'Potencia máxima que entrega el cargador. Si dos conectores cargan a la vez, el gabinete la reparte entre ellos (ADR 0026).',
  'cp.connectorPowerKw': 'Conector {n} (kW)',
  'cp.editPower': 'Editar potencia',
  'cp.powerSaved': 'Potencia actualizada',
  'cp.connectorsHelp':
    'Un conector por cada toma del cargador, con el estándar (CCS2, CCS1, GB/T…), el tipo de corriente y la potencia máxima en kW. Se muestran en la app tal cual.',
  'cp.template': 'Plantilla',
  'cp.securityProfile': 'Perfil de seguridad',
  'cp.heartbeat': 'Heartbeat (s)',
  'cp.addConnector': 'Añadir conector',
  'cp.removeConnector': 'Quitar',
  'cp.created': 'Cargador creado. Emite su credencial para instalarlo.',
  'cp.tab.overview': 'Resumen',
  'cp.tab.configuration': 'Configuración',
  'cp.tab.commands': 'Comandos',
  'cp.tab.sessions': 'Sesiones',
  'cp.tab.timeline': 'Bitácora',
  'cp.tab.alarms': 'Alarmas',
  'cp.commissioning': 'Comisionamiento',
  'cp.issueCredential': 'Emitir credencial',
  'cp.credentialTitle': 'Credencial emitida (se muestra una sola vez)',
  'cp.credentialHelp':
    'Configura en el cargador: usuario = identidad, contraseña = esta clave (Basic Auth, perfil 2). URL del CSMS:',
  'cp.credentialExpires': 'Caduca',
  'cp.applyTemplate': 'Aplicar plantilla',
  'cp.syncConfig': 'Leer configuración (deriva)',
  'cp.drift': 'Con deriva',
  'cp.noDrift': 'Sin deriva',
  'cp.key': 'Clave',
  'cp.desired': 'Deseado',
  'cp.observed': 'Observado',
  'cp.readonly': 'Solo lectura',
  'cp.override': 'Cambiar valor',
  'cp.overrideValue': 'Nuevo valor',
  'cp.lifecycleChange': 'Cambiar estado',
  'cp.lifecycleTo': 'Nuevo estado',
  'cp.command': 'Comando',
  'cp.sendCommand': 'Enviar comando',
  'cp.commandPayload': 'Parámetros (JSON)',
  'cp.commandResult': 'Resultado',
  'cp.commandHistory': 'Historial de comandos',
  'cp.commandSensitive':
    'Este comando afecta la operación del cargador. Confirma y deja el motivo.',
  'cp.commandOk': 'Comando enviado',
  'cp.timelineKinds': 'Tipos',
  'cp.transactions': 'Transacciones OCPP',
  'cp.credential': 'Credencial',
  'cp.credentialNone': 'Sin credencial emitida',
  'cp.credentialIssued': 'Emitida',
  'cp.visibleInApp': 'Visible en la app',
  'cp.gatewayUnavailable': 'El enlace con el gateway OCPP no está configurado en este ambiente',

  'lifecycle.INVENTORIED': 'Inventariado',
  'lifecycle.PROVISIONED': 'Aprovisionado',
  'lifecycle.CONNECTED_PENDING': 'Conectado (pendiente)',
  'lifecycle.CONFIGURED': 'Configurado',
  'lifecycle.TESTED': 'Probado',
  'lifecycle.OPERATIONAL': 'Operativo',
  'lifecycle.MAINTENANCE': 'Mantenimiento',
  'lifecycle.REJECTED': 'Rechazado',
  'lifecycle.DECOMMISSIONED': 'Retirado',

  'sessions.title': 'Sesiones',
  'sessions.no': 'N.º',
  'sessions.chargePoint': 'Cargador',
  'sessions.evse': 'EVSE',
  'sessions.driver': 'Conductor',
  'sessions.state': 'Estado',
  'sessions.started': 'Inicio',
  'sessions.ended': 'Fin',
  'sessions.energy': 'Energía',
  'sessions.cost': 'Costo',
  'sessions.payment': 'Pago',
  'sessions.channel': 'Canal',
  'sessions.stop': 'Detener',
  'sessions.cancel': 'Cancelar sesión',
  'sessions.start': 'Iniciar sesión de prueba',
  'sessions.startHelp': 'Lanza RemoteStartTransaction como operador (canal TEST u OPERATOR).',
  'sessions.events': 'Eventos',
  'sessions.costBreakdown': 'Desglose de costo',
  'sessions.costRunning': 'Costo en curso (estimado)',
  'sessions.costFinal': 'Cálculo final',
  'sessions.costNone': 'Todavía no hay cálculo de costo para esta sesión.',
  'sessions.computedAt': 'calculado',
  'sessions.recalculate': 'Recalcular costo',
  'sessions.settle': 'Liquidar',
  'sessions.charge': 'Cobrar ahora',
  'sessions.receipt': 'Recibo',
  'sessions.receiptPdf': 'Recibo PDF',
  'sessions.stopRequested': 'Parada solicitada',
  'sessions.filterState': 'Estado',
  'sessions.tariff': 'Tarifa',
  'sessions.idle': 'Ocupación',
  'sessions.chargingTime': 'Tiempo de carga',
  'sessions.transaction': 'Transacción OCPP',
  'sessions.runningCost': 'Costo en curso',
  'sessions.exposure': 'Tope de exposición',
  'sessions.lines': 'Líneas',
  'sessions.line.dimension': 'Concepto',
  'sessions.line.quantity': 'Cantidad',
  'sessions.line.unitPrice': 'Precio unitario',
  'sessions.line.amount': 'Importe',
  'sessions.total': 'Total',
  'sessions.subtotal': 'Subtotal',
  'sessions.tax': 'Impuestos',
  'sessions.discount': 'Descuento',
  'sessions.dimension.ENERGY': 'Energía',
  'sessions.dimension.TIME': 'Tiempo de carga',
  'sessions.dimension.PARKING_TIME': 'Ocupación',
  'sessions.dimension.FLAT': 'Cargo por sesión',
  'sessions.dimension.ADJUSTMENT': 'Ajuste',
  'sessions.dimension.CAP': 'Tope',
  'sessions.cap.minPrice': 'Cobro mínimo por conexión',
  'sessions.cap.maxPrice': 'Tope de precio',

  'tariffs.title': 'Tarifas',
  'tariffs.new': 'Nueva tarifa',
  'tariffs.code': 'Código',
  'tariffs.codeHelp': 'Mayúsculas, dígitos y guiones; identifica la tarifa en recibos y auditoría.',
  'tariffs.name': 'Nombre',
  'tariffs.nameHelp': 'Nombre comercial que ve el operador (p. ej. Tarifa VOLT).',
  'tariffs.currency': 'Moneda',
  'tariffs.versions': 'Versiones',
  'tariffs.version': 'Versión',
  'tariffs.published': 'Publicada',
  'tariffs.draft': 'Borrador',
  'tariffs.retired': 'Retirada',
  'tariffs.validFrom': 'Vigente desde',
  'tariffs.validTo': 'Vigente hasta',
  'tariffs.open': 'Sin fin',
  'tariffs.publish': 'Publicar',
  'tariffs.publishAt': 'Vigente desde (vacío = ahora)',
  'tariffs.retire': 'Retirar',
  'tariffs.newVersion': 'Nueva versión',
  'tariffs.definition': 'Definición (OCPI 2.2.1, JSON)',
  'tariffs.validate': 'Validar y simular',
  'tariffs.valid': 'Definición válida',
  'tariffs.notes': 'Notas',
  'tariffs.taxIncluded': 'Precios con impuesto incluido',
  'tariffs.assignments': 'Asignaciones',
  'tariffs.assignmentsHelp':
    'Una asignación dice qué tarifa cobra cada alcance (plataforma, sede, cargador o conector) para un segmento de conductores. Sin asignación vigente, un conector no puede iniciar carga.',
  'tariffs.assignmentsWhere': 'Dónde aplica esta tarifa ahora mismo.',
  'tariffs.assignmentHistory': 'Historial de asignaciones',
  'tariffs.noAssignments': 'Esta tarifa no está asignada a ningún alcance: nadie la cobra todavía.',
  'tariffs.assign': 'Asignar tarifa',
  'tariffs.assigned': 'Tarifa asignada',
  'tariffs.assignFrom': 'Vigente desde (vacío = ahora)',
  'tariffs.scope': 'Alcance',
  'tariffs.scopeId': 'Id del alcance',
  'tariffs.scopeTarget': 'Aplicar a',
  'tariffs.scope.PLATFORM': 'Toda la plataforma',
  'tariffs.scope.TENANT': 'Operador VOLT',
  'tariffs.scope.SITE': 'Una sede',
  'tariffs.scope.CHARGE_POINT': 'Un cargador',
  'tariffs.scope.CONNECTOR': 'Un conector',
  'tariffs.scope.CONNECTOR_TYPE': 'Un tipo de conector',
  'tariffs.scopeHelp':
    'Gana la asignación más específica (conector > cargador > sede > operador > plataforma); a igual alcance y segmento, la de mayor prioridad y luego la más reciente.',
  'tariffs.segment': 'Segmento',
  'tariffs.segmentName.PUBLIC': 'PUBLIC: cualquier conductor',
  'tariffs.segmentName.INTERNAL': 'INTERNAL: uso interno, sin cobro',
  'tariffs.segmentName.EMPLOYEE': 'EMPLOYEE: empleados',
  'tariffs.segmentName.ADHOC': 'ADHOC: sin cuenta',
  'tariffs.segment.custom': 'Otro (MEMBER:… o FLEET:…)',
  'tariffs.segmentHelp':
    'PUBLIC es el precio de cualquier conductor y el respaldo de los demás segmentos.',
  'tariffs.priority': 'Prioridad',
  'tariffs.priorityHelp': 'Solo importa entre asignaciones del mismo alcance y segmento.',
  'tariffs.end': 'Terminar',
  'tariffs.resolve': 'Resolver tarifa de un EVSE',
  'tariffs.publishConfirm':
    'Publicar cambia el precio para las sesiones nuevas desde la fecha indicada. Las sesiones en curso conservan su tarifa.',
  'tariffs.bootstrap': 'Crear tarifa base de Volt',
  'tariffs.bootstrapHelp':
    'Crea VOLT-BASE con los precios acordados (ADR 0018), publicada y asignada a toda la plataforma. Si ya existe, no cambia nada.',
  'tariffs.noTariffs': 'Aún no hay tarifas. Crea la tarifa base de Volt o una nueva.',
  'tariffs.noActive':
    'Sin versión publicada: los conectores con esta tarifa no pueden iniciar carga hasta publicar una.',
  'tariffs.noActiveShort': 'sin publicar',
  'tariffs.activeNow': 'Versión vigente',
  'tariffs.summary': 'Resumen',
  'tariffs.status.DRAFT': 'Borrador',
  'tariffs.status.SCHEDULED': 'Programada',
  'tariffs.status.ACTIVE': 'Vigente',
  'tariffs.status.RETIRED': 'Retirada',
  'tariffs.status.SUPERSEDED': 'Reemplazada',
  'tariffs.audit': 'Cambios de tarifas',
  'tariffs.elements': 'Elementos',
  'tariffs.pricePerKwh': 'COP por kWh',
  'tariffs.idleFee': 'Ocupación',
  'tariffs.jsonInvalid': 'JSON inválido',
  'tariffs.versionSaved': 'Versión guardada como borrador. Publícala cuando esté lista.',
  'tariffs.guideTitle': '¿Cómo se configuran las tarifas?',
  'tariffs.guide1':
    'Crea una tarifa con un código (p. ej. VOLT-BASE) y un nombre. La tarifa es el contenedor; los precios viven en sus versiones.',
  'tariffs.guide2':
    'Dentro de la tarifa crea una versión con el formulario: precio por kWh (con franjas horarias si quieres), ocupación después de cargar, cargos adicionales e impuesto. Valida y mira el ejemplo antes de guardar.',
  'tariffs.guide3':
    'Publica la versión: desde ese momento las sesiones nuevas cobran con ella y las anteriores conservan su precio. Cada cambio de precio es una versión nueva.',
  'tariffs.guide4':
    'Asigna la tarifa a toda la plataforma, a una sede, a un cargador o a un conector, por segmento de conductor. Gana la asignación más específica.',
  'tariffs.editor.mode.form': 'Formulario',
  'tariffs.editor.mode.json': 'JSON (avanzado)',
  'tariffs.editor.jsonOnly':
    'La última versión usa reglas que el formulario no cubre (tramos por kWh, potencia o duración). Se edita como JSON.',
  'tariffs.editor.energy': 'Energía',
  'tariffs.editor.energyPrice': 'Precio por kWh',
  'tariffs.editor.energyHelp':
    'Precio que aplica siempre que ninguna franja horaria coincida. Sin impuesto salvo que indiques un IVA.',
  'tariffs.editor.bandsHelp':
    'Franjas horarias opcionales con precio distinto, en hora local de la sede. Una franja que termina antes de empezar cruza la medianoche (20:00 a 05:00).',
  'tariffs.editor.from': 'Desde',
  'tariffs.editor.to': 'Hasta',
  'tariffs.editor.days': 'Días',
  'tariffs.editor.days.ALL': 'Todos los días',
  'tariffs.editor.days.WEEKDAYS': 'Lunes a viernes',
  'tariffs.editor.days.WEEKEND': 'Sábado y domingo',
  'tariffs.editor.addBand': 'Añadir franja horaria',
  'tariffs.editor.remove': 'Quitar',
  'tariffs.editor.idle': 'Ocupación después de cargar',
  'tariffs.editor.idleEnabled': 'Cobrar ocupación mientras el vehículo siga conectado',
  'tariffs.editor.idleGrace': 'Minutos de cortesía',
  'tariffs.editor.idlePrice': 'Precio por minuto',
  'tariffs.editor.idleMax': 'Tope de minutos cobrables (vacío = sin tope)',
  'tariffs.editor.idleStart': 'La ocupación empieza',
  'tariffs.editor.idleStart.EARLIEST':
    'Al terminar la carga o al pausarla el vehículo (lo primero)',
  'tariffs.editor.idleStart.TRANSACTION_END': 'Solo al terminar la transacción',
  'tariffs.editor.idleStart.SUSPENDED_EV': 'Cuando el vehículo pausa la carga',
  'tariffs.editor.extras': 'Otros cobros (opcional)',
  'tariffs.editor.sessionFee': 'Cargo fijo por sesión',
  'tariffs.editor.timePrice': 'Precio por minuto de carga',
  'tariffs.editor.timeHelp': 'Se suma a la energía mientras carga. Vacío = solo se cobra energía.',
  'tariffs.editor.tax': 'Impuesto y topes',
  'tariffs.editor.vat': 'IVA (%)',
  'tariffs.editor.vatHelp':
    'Vacío = servicio excluido de IVA (ADR 0018). Con un porcentaje, el recibo lo desglosa.',
  'tariffs.editor.taxIncluded': 'Los precios escritos ya incluyen el impuesto',
  'tariffs.editor.minPrice': 'Mínimo por sesión',
  'tariffs.editor.maxPrice': 'Máximo por sesión',
  'tariffs.editor.description': 'Descripción para el conductor (opcional)',
  'tariffs.editor.descriptionHelp': 'Texto corto que la app muestra junto al precio.',
  'tariffs.editor.preview': 'Vista previa',
  'tariffs.editor.example':
    'Ejemplo: 30 kWh en 45 minutos desde las 10:00 y 20 minutos de ocupación',
  'tariffs.editor.exampleTotal': 'Total del ejemplo',
  'tariffs.editor.validated': 'Definición válida',
  'tariffs.editor.saveDraft': 'Guardar borrador',
  'tariffs.editor.invalidNumber':
    'Revisa los precios: solo números, con punto como separador decimal.',

  'sim.title': 'Simulador de precio',
  'sim.intro':
    'Calcula el costo de una sesión hipotética con una tarifa publicada o una definición propia.',
  'sim.tariffVersion': 'Versión de tarifa',
  'sim.startAt': 'Inicio',
  'sim.durationMin': 'Duración de carga (min)',
  'sim.energyWh': 'Energía (Wh)',
  'sim.idleMin': 'Ocupación después de cargar (min)',
  'sim.powerW': 'Potencia (W)',
  'sim.run': 'Simular',
  'sim.result': 'Resultado',

  'params.title': 'Parámetros',
  'params.key': 'Clave',
  'params.default': 'Por defecto',
  'params.effective': 'Valor efectivo',
  'params.scopes': 'Alcances',
  'params.values': 'Valores vigentes',
  'params.set': 'Fijar valor',
  'params.scopeType': 'Alcance',
  'params.scopeId': 'Id del alcance (uuid)',
  'params.value': 'Valor (JSON)',
  'params.description': 'Descripción',
  'params.saved': 'Parámetro guardado',
  'params.restart': 'Requiere reinicio',
  'params.sensitive': 'Solo administradores',

  'pay.title': 'Pagos',
  'pay.payments': 'Cobros',
  'pay.debts': 'Deudas',
  'pay.webhooks': 'Webhooks',
  'pay.reconcile': 'Conciliar hoy',
  'pay.runJobs': 'Ejecutar cobros pendientes',
  'pay.reference': 'Referencia',
  'pay.amount': 'Importe',
  'pay.kind': 'Tipo',
  'pay.status': 'Estado',
  'pay.psp': 'PSP',
  'pay.session': 'Sesión',
  'pay.driver': 'Conductor',
  'pay.reverse': 'Anular o devolver',
  'pay.registerVoid': 'Registrar anulación',
  'pay.resolveApproved': 'Marcar aprobada',
  'pay.resolveFailed': 'Marcar fallida',
  'pay.reverseAmount': 'Importe a devolver (vacío = total)',
  'pay.reversed': 'Devolución solicitada',
  'pay.debtAmount': 'Deuda',
  'pay.attempts': 'Intentos',
  'pay.nextAttempt': 'Próximo intento',
  'pay.payLink': 'Enlace de pago',
  'pay.createLink': 'Crear enlace',
  'pay.waive': 'Condonar',
  'pay.retry': 'Reintentar cobro',
  'pay.waived': 'Deuda condonada',
  'pay.event': 'Evento',
  'pay.received': 'Recibido',
  'pay.outcome': 'Resultado',
  'pay.checksum': 'Checksum',
  'pay.unavailable': 'Los pagos no están configurados en este ambiente',
  'pay.reconciled': 'Conciliación ejecutada',
  'pay.summary': 'Resumen',
  'pay.period': 'Período',
  'pay.period.today': 'Hoy',
  'pay.period.7d': '7 días',
  'pay.period.month': 'Este mes',
  'pay.period.30d': '30 días',
  'pay.collected': 'Cobrado',
  'pay.refunded': 'Devuelto',
  'pay.voided': 'anulado',
  'pay.net': 'Neto',
  'pay.pending': 'Pendiente',
  'pay.declined': 'Rechazado',
  'pay.errors': 'errores técnicos',
  'pay.openDebt': 'Deuda abierta',
  'pay.billed': 'Facturado en sesiones liquidadas',
  'pay.paidSessions': 'pagado',
  'pay.byDay': 'Por día',
  'pay.byMethod': 'Por medio de pago',
  'pay.day': 'Día',
  'pay.count': 'Cobros',
  'pay.method': 'Medio',
  'pay.method.CARD': 'Tarjeta',
  'pay.method.WALLET': 'Nequi',
  'pay.method.LINK': 'Enlace de pago',
  'pay.method.UNKNOWN': 'Otro',
  'pay.provider': 'Estado de Wompi',
  'pay.providerNone': 'Sin pasarela de pago configurada en este ambiente.',
  'pay.env.sandbox': 'Sandbox de Wompi (pruebas, sin dinero real)',
  'pay.env.production': 'Producción',
  'pay.env.fake': 'Emulador (sin Wompi)',
  'pay.merchantOk': 'Pasarela en línea ({latency} ms)',
  'pay.merchantFail': 'Pasarela sin respuesta: {error}',
  'pay.lastCapture': 'Último cobro aprobado',
  'pay.lastWebhook': 'Último webhook recibido',
  'pay.webhooks24h': 'Webhooks en 24 h',
  'pay.applied': 'aplicados',
  'pay.invalidChecksum': 'con checksum inválido',
  'pay.otherOutcome': 'otros',
  'pay.last24h': 'Cobros en 24 h',
  'pay.approved': 'aprobados',
  'pay.declinedShort': 'rechazados',
  'pay.errorsShort': 'errores',
  'pay.pendingNow': 'Pagos pendientes ahora',
  'pay.reconAlarms': 'Alarmas de conciliación abiertas',
  'pay.sourcesStuck': 'medios de pago sin confirmar',
  'pay.never': 'Nunca',
  'pay.providerHelp':
    'Cómo saber que Wompi funciona: la conexión responde, los cobros del día aparecen aprobados, cada cobro trae su webhook aplicado y no hay alarmas de conciliación. La prueba automática contra el sandbox corre en cada push (Actions → CI). El dinero que realmente entra a la cuenta, con comisiones y retenciones, se ve en el panel de Wompi.',
  'pay.from': 'Desde',
  'pay.to': 'Hasta',
  'pay.pspReference': 'Ref. Wompi',
  'pay.einvoicing': 'Facturación electrónica',
  'ein.title': 'Facturación electrónica (DIAN, Alegra)',
  'ein.help':
    'Por cada cobro aprobado se emite una factura electrónica y por cada devolución una nota crédito, desde el worker y a través de Alegra. La emisión se enciende con el parámetro einvoicing.enabled; por defecto solo se facturan cobros de la pasarela en producción (einvoicing.sandbox_payments).',
  'ein.noProvider': 'Sin proveedor operativo: {reason}',
  'ein.provider': 'Proveedor',
  'ein.enabled': 'Emisión encendida',
  'ein.disabled': 'Emisión apagada (parámetro einvoicing.enabled)',
  'ein.since': 'Cobros desde',
  'ein.sandbox': 'Incluye cobros de sandbox',
  'ein.sendEmail': 'Correo al cliente',
  'ein.lastAccepted': 'Última aceptada',
  'ein.oldestPending': 'Pendiente más antigua',
  'ein.check': 'Comprobar cuenta',
  'ein.checking': 'Comprobando la cuenta…',
  'ein.checkOk': 'La cuenta está lista para emitir.',
  'ein.problems': 'Problemas encontrados',
  'ein.company': 'Empresa',
  'ein.numberTemplates': 'Numeraciones',
  'ein.electronic': 'electrónica',
  'ein.notElectronic': 'no electrónica',
  'ein.next': 'siguiente',
  'ein.items': 'Ítems por línea',
  'ein.itemMissing': 'sin ítem',
  'ein.taxes': 'impuestos',
  'ein.noTaxes': 'sin impuestos',
  'ein.finalConsumer': 'Consumidor final',
  'ein.finalConsumerMissing': 'no existe (se crea con la primera factura sin documento)',
  'ein.run': 'Ejecutar ciclo ahora',
  'ein.ran':
    'Ciclo ejecutado: {enqueued} encolados, {issued} emitidos, {accepted} aceptados, {rejected} rechazados, {errors} errores.',
  'ein.documents': 'Documentos',
  'ein.kind': 'Tipo',
  'ein.kind.INVOICE': 'Factura',
  'ein.kind.CREDIT_NOTE': 'Nota crédito',
  'ein.status.PENDING': 'Pendiente',
  'ein.status.SENT': 'Enviada',
  'ein.status.ACCEPTED': 'Aceptada',
  'ein.status.REJECTED': 'Rechazada',
  'ein.status.ERROR': 'Error',
  'ein.status.SKIPPED': 'Omitida',
  'ein.all': 'Todos',
  'ein.buyer': 'Adquiriente',
  'ein.number': 'Número',
  'ein.total': 'Total',
  'ein.attempts': 'Intentos',
  'ein.nextAttempt': 'Próximo intento',
  'ein.error': 'Último error',
  'ein.retry': 'Reintentar',
  'ein.retryTitle': 'Reintentar la emisión',
  'ein.retryHelp':
    'Vuelve a encolar el documento. Si fue rechazado por la DIAN se emite uno nuevo con otro número y con el documento actual del conductor.',
  'ein.skip': 'Omitir',
  'ein.skipTitle': 'Omitir el documento',
  'ein.skipHelp': 'No se emitirá. Indica el motivo (por ejemplo, carga de prueba).',
  'ein.cufe': 'CUFE',
  'ein.pdf': 'PDF',
  'ein.emailSent': 'Correo enviado',
  'ein.warnings': 'Advertencias',
  'ein.session': 'Sesión',
  'ein.credentials': 'Credenciales en uso',
  'ein.schemeBasic': 'autenticación Basic con el token de API',
  'ein.schemeBearer': 'autenticación Bearer con un JWT',
  'ein.tokenInfo': 'token de {length} caracteres ({shape})',
  'ein.tokenShape.jwt': 'con forma de JWT',
  'ein.tokenShape.token': 'token clásico',
  'ein.tokenShape.suspicious': 'con caracteres raros: vuelve a copiarlo',
  'ein.probeTitle': 'Probar otras credenciales (no se guardan)',
  'ein.probeHelp':
    'Pega aquí el correo y el token tal como los tienes en Alegra: la API los prueba desde la nube sin guardarlos ni registrarlos. Si aquí funcionan y Comprobar cuenta no, los valores de Secret Manager son distintos.',
  'ein.probeUser': 'Correo de Alegra',
  'ein.probeToken': 'Token de API',
  'ein.probeRun': 'Probar',
  'ein.probeResult': 'Resultado con las credenciales de prueba (no quedaron guardadas).',
  'ein.compareTitle': 'Comparación con los secretos guardados:',
  'ein.compareUser.exact': 'el correo es el mismo',
  'ein.compareUser.case':
    'el correo es el mismo salvo mayúsculas o minúsculas (vuelve a cargarlo tal como lo escribiste aquí)',
  'ein.compareUser.different':
    'el correo guardado es otro (carga este como nueva versión de alegra-api-user)',
  'ein.compareTokenSame': 'el token es idéntico al guardado',
  'ein.compareTokenDiff':
    'el token guardado es distinto de este ({length}): carga este como nueva versión de alegra-api-token',
  'ein.compareSameLength': 'misma longitud',
  'ein.compareLengthDiff': 'diferencia de longitud {delta}',
  'ein.setup': 'Configuración',
  'ein.setupHelp':
    'Primero toca Comprobar cuenta para leer los ítems y las numeraciones de Alegra; luego elige el ítem del servicio de carga (sin IVA), guarda y enciende los interruptores. Todo queda en los parámetros einvoicing.*.',
  'ein.checkFirst': 'Toca Comprobar cuenta para ver los ítems y las numeraciones de la cuenta.',
  'ein.item': 'Ítem de Alegra para las líneas del cobro',
  'ein.itemHelp':
    'Debe ser un ítem de tipo servicio sin impuestos. El id aparece entre paréntesis.',
  'ein.itemNone': 'Sin ítem (la emisión fallará)',
  'ein.invoiceTemplate': 'Numeración de factura electrónica',
  'ein.creditTemplate': 'Numeración de nota crédito',
  'ein.preferred': 'La preferida de la cuenta',
  'ein.manualId': 'Id manual',
  'ein.save': 'Guardar configuración',
  'ein.saved': 'Configuración guardada.',
  'ein.switches': 'Interruptores',
  'ein.toggleEnabled':
    'Emisión encendida: cada cobro aprobado genera una factura electrónica real ante la DIAN',
  'ein.toggleSandbox':
    'Incluir cobros del sandbox de Wompi (solo para la prueba controlada en staging; los documentos son reales)',
  'ein.enableTitle': 'Encender la emisión',
  'ein.enableHelp':
    'A partir de ahora cada cobro aprobado (y cada devolución) se envía a Alegra y a la DIAN. Los documentos son reales y no se pueden borrar; un error se corrige con nota crédito.',
  'ein.disableTitle': 'Apagar la emisión',
  'ein.disableHelp':
    'Los cobros nuevos no se facturarán hasta volver a encenderla; los documentos en curso terminan.',
  'ein.sandboxTitle': 'Incluir cobros de sandbox',
  'ein.sandboxHelp':
    'Solo para probar la integración: una carga pagada con una tarjeta de prueba generará una factura electrónica real ante la DIAN. Apágalo al terminar la prueba.',
  'ein.sandboxOffTitle': 'Dejar de incluir cobros de sandbox',

  'drivers.title': 'Conductores',
  'drivers.new': 'Nuevo conductor',
  'drivers.email': 'Correo',
  'drivers.phone': 'Teléfono',
  'drivers.firstName': 'Nombres',
  'drivers.lastName': 'Apellidos',
  'drivers.phoneVerified': 'Celular verificado',
  'drivers.phoneUnverified': 'Celular sin verificar',
  'drivers.name': 'Nombre',
  'drivers.billing': 'Cobro',
  'drivers.block': 'Bloquear',
  'drivers.unblock': 'Desbloquear',
  'drivers.paymentMethods': 'Medios de pago',
  'drivers.sessions': 'Sesiones recientes',
  'drivers.debts': 'Deudas',
  'drivers.segment': 'Segmento',
  'drivers.document': 'Documento',
  'drivers.wantsInvoice': 'Factura electrónica',
  'drivers.vehicle': 'Vehículo',
  'drivers.blocked': 'Bloqueado',
  'drivers.ok': 'Al día',
  'drivers.blockedDebt': 'Bloqueado por deuda',
  'drivers.blockedManual': 'Bloqueado manualmente',

  'alarms.title': 'Alarmas',
  'alarms.kind': 'Tipo',
  'alarms.severity': 'Severidad',
  'alarms.chargePoint': 'Cargador',
  'alarms.firstSeen': 'Primera vez',
  'alarms.lastSeen': 'Última vez',
  'alarms.occurrences': 'Veces',
  'alarms.resolve': 'Resolver',
  'alarms.resolution': 'Resolución',
  'alarms.includeResolved': 'Incluir resueltas',
  'alarms.resolved': 'Alarma resuelta',

  'audit.title': 'Auditoría',
  'audit.when': 'Cuándo',
  'audit.actor': 'Quién',
  'audit.action': 'Acción',
  'audit.entity': 'Entidad',
  'audit.outcome': 'Resultado',
  'audit.verify': 'Verificar cadena',
  'audit.chainOk': 'Cadena íntegra',
  'audit.chainBroken': 'Cadena rota en el registro',
  'audit.checked': 'registros verificados',
  'audit.filterAction': 'Acción (prefijo)',
  'audit.filterEntity': 'Id de entidad',
  'audit.filterActor': 'Actor',
  'audit.loadMore': 'Cargar más',

  'staff.title': 'Personal',
  'staff.invite': 'Invitar',
  'staff.email': 'Correo',
  'staff.name': 'Nombre',
  'staff.role': 'Rol',
  'staff.sites': 'Sedes (SITE_OWNER)',
  'staff.status': 'Estado',
  'staff.linked': 'Identidad vinculada',
  'staff.mfa': 'MFA',
  'staff.lastLogin': 'Último ingreso',
  'staff.disable': 'Deshabilitar',
  'staff.enable': 'Habilitar',
  'staff.invited':
    'Invitación creada. La persona entra con ese correo (verificado) en Identity Platform.',
  'staff.roleHelp.ADMIN': 'Todo: personal, tarifas, configuración, pagos.',
  'staff.roleHelp.OPERATIONS':
    'Operación: cargadores, comandos, comisionamiento, sesiones, alarmas, parámetros.',
  'staff.roleHelp.SUPPORT':
    'Soporte: sesiones, RemoteStop y desbloqueo, conductores, deudas y devoluciones hasta un límite.',
  'staff.roleHelp.READ_ONLY': 'Solo lectura, incluida la auditoría.',
  'staff.roleHelp.SITE_OWNER': 'Propietario de sede: solo lectura de sus sedes.',
  'staff.me': 'Tú',
  'staff.method': 'Acceso',

  'integrations.title': 'Integraciones',
  'integrations.subtitle':
    'Claves del canal público de estado de las estaciones (/v1/public/stations): una por consumidor, con orígenes permitidos opcionales.',
  'integrations.create': 'Nueva clave',
  'integrations.label': 'Etiqueta',
  'integrations.labelHelp':
    'Para quién es: «Web supercargadores.co», «Pantallas del centro comercial».',
  'integrations.origins': 'Orígenes permitidos',
  'integrations.originsHelp':
    'Uno por línea, con la forma https://dominio (sin ruta), hasta 10. Deje vacío para aceptar cualquier origen; en una página web pública la clave es visible, así que restrinja el origen.',
  'integrations.anyOrigin': 'Cualquier origen',
  'integrations.publicWarning':
    'Una clave dentro de una página web la puede leer cualquiera que vea el código fuente. La protección real es el origen permitido, el límite por clave y la revocación, no el secreto. Para un servicio de señalización que no es navegador, deje los orígenes vacíos.',
  'integrations.issuedTitle': 'Clave creada: {label}',
  'integrations.issuedHelp':
    'Cópiela ahora: no se vuelve a mostrar. Se envía en la cabecera Authorization: Bearer (o X-Volt-Key) y, para EventSource, en ?key= de la URL.',
  'integrations.prefix': 'Prefijo',
  'integrations.lastUsed': 'Último uso',
  'integrations.neverUsed': 'Sin uso',
  'integrations.active': 'Activa',
  'integrations.revoked': 'Revocada',
  'integrations.revoke': 'Revocar',
  'integrations.revokeHelp':
    'La web o las pantallas que usen esta clave dejan de recibir datos en el acto (hasta 30 segundos en otras instancias). No se puede deshacer; cree otra clave si hace falta.',
  'integrations.revokedMessage': 'Clave revocada.',

  'status.Available': 'Disponible',
  'status.Preparing': 'Preparando',
  'status.Charging': 'Cargando',
  'status.SuspendedEV': 'Pausado por el vehículo',
  'status.SuspendedEVSE': 'Pausado por el cargador',
  'status.Finishing': 'Finalizando',
  'status.Reserved': 'Reservado',
  'status.Unavailable': 'No disponible',
  'status.Faulted': 'Con falla',
  'status.Offline': 'Sin conexión',
} as const;

export type MessageKey = keyof typeof es;
